import React, { useState } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView } from '@digital/ui';
import { getAllProjetoRelatorios } from '@app/api/crf/crfProjeto';
import ResultCicloAno from './resultCicloAno';
import ResultPluriAnual from './resultCicloPluriAnual';
import DadosGerais from './dadosGerais';

const CrfRelatorioProjetoCicloAnoPluriAnual = () => {
  const [projetos, setProjetos] = useState(() => getAllProjetoRelatorios);
  const idTodos = '00000000-0000-0000-0000-000000000000';
  const urlTodosProjeto =
    '/Cr/relatorioProjetoCicloAnoPluriAnual/detail/00000000-0000-0000-0000-000000000000/cicoOrcamentario';
  const idAbaGeral = 'dadosGerais';

  const getValueUrl = () => {
    const latUrl = window.location.pathname.split('/').pop();
    if (latUrl === idAbaGeral) {
      const url = window.location.origin;
      const urlFinal = `${url}${urlTodosProjeto}`;
      window.location.href = urlFinal;
    }
  };

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      filterPredicate={(item, value) =>
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        (item.numero && item.numero.toLowerCase().includes(value.toLowerCase())) ||
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.crfDisciplinaProjetoNome && item.crfDisciplinaProjetoNome.toLowerCase().includes(value.toLowerCase()))
      }
      titleExtractor={item => (item.id === idTodos ? `${item.nome}` : `${item.codigo} - ${item.nome}`)}
      descriptionExtractor={item => item.crfDisciplinaProjetoNome || ''}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          if (selectedItem && selectedItem.id === idTodos) {
            getValueUrl();
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="cicloOrcamentario" noform title="CICLO ORÇAMENTARIO">
                    <ResultCicloAno projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                    <ResultPluriAnual
                      projetoId={selectedItem.id}
                      projetoCodigo={selectedItem.codigo}
                      nomeProjeto={selectedItem.nome}
                    />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          } else {
            return (
              <CompositeView>
                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id={`${idAbaGeral}`} noform title="DADOS GERAIS">
                    <DadosGerais projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="cicoOrcamentario" noform title="CICLO ORÇAMENTARIO">
                    <ResultCicloAno projetoId={selectedItem.id} />
                  </GridView>
                ) : (
                  () => { }
                )}

                {true && selectedItem ? (
                  <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                    <ResultPluriAnual
                      projetoId={selectedItem.id}
                      projetoCodigo={selectedItem.codigo}
                      nomeProjeto={selectedItem.nome}
                    />
                  </GridView>
                ) : (
                  () => { }
                )}
              </CompositeView>
            );
          }
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default CrfRelatorioProjetoCicloAnoPluriAnual;
